import React, { Component } from 'react';
import DataControlComponent from '../../components/admin/data-control/DataControlComponent';

export default class DataControlContainer extends Component {
    render(){
        return <DataControlComponent />;
    }
}
